const locale = {
  noData: '暂无数据'
};
export default locale;